import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute('/app/startup/$id/settings/analytics')({
  component: () => null,
})
